import React from 'react'

const SelectClientContext = React.createContext()

const { Provider } = SelectClientContext

function useSelectClient() {
  return React.useContext(SelectClientContext)
}

export { Provider, useSelectClient }
